import { Injectable, OnDestroy } from '@angular/core';

import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

export type EventsOrActionsOf<T> = { [K in keyof T]: { name: K; payload: T[K] } }[keyof T];
export type EmptyObject = { [K in any]: never };

@Injectable()
export class GenericBlocService<E, A> implements OnDestroy {
  readonly events$: Observable<EventsOrActionsOf<E>>;
  readonly actions$: Observable<EventsOrActionsOf<A>>;

  private events = new Subject<EventsOrActionsOf<E>>();
  private actions = new Subject<EventsOrActionsOf<A>>();

  constructor() {
    this.actions$ = this.actions.asObservable();
    this.events$ = this.events.asObservable();
  }

  addEvent<EventName extends keyof E>(name: EventName, payload: E[EventName]) {
    this.events.next({ name, payload });
  }

  addAction<ActionName extends keyof A>(name: ActionName, payload: A[ActionName]) {
    this.actions.next({ name, payload });
  }

  ngOnDestroy() {
    this.events.complete();
    this.actions.complete();
  }
}
